import { render, staticRenderFns } from "./GuidelineHeading.vue?vue&type=template&id=35e47154&scoped=true&"
import script from "./GuidelineHeading.vue?vue&type=script&lang=ts&"
export * from "./GuidelineHeading.vue?vue&type=script&lang=ts&"
import style0 from "./GuidelineHeading.vue?vue&type=style&index=0&id=35e47154&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e47154",
  null
  
)

export default component.exports